import { combineReducers } from "redux";
import addNumber from './Numbers/AddNumber';
import editNumber from './Numbers/EditNumber';
import assignNumber from './Numbers/AssignNumber';

// All numbers loading state
const defaultLoadingAllNumbers = false;
const loadingAllNumbers = (state = defaultLoadingAllNumbers, action) => {
  switch (action.type) {
    case 'ALL_NUMBERS':
      return true;
    case 'ALL_NUMBERS_SUCCESS':
    case 'ALL_NUMBERS_ERROR':
      return false;
    default:
      return state;
  }
};

// Company numbers loading state
const defaultLoadingCompanyNumbers = false;
const loadingCompanyNumbers = (state = defaultLoadingCompanyNumbers, action) => {
  switch (action.type) {
    case 'COMPANY_NUMBERS':
      return true;
    case 'COMPANY_NUMBERS_SUCCESS':
    case 'COMPANY_NUMBERS_ERROR':
      return false;
    default:
      return state;
  }
};

// User numbers loading state
const defaultLoadingUserNumbers = false;
const loadingUserNumbers = (state = defaultLoadingUserNumbers, action) => {
  switch (action.type) {
    case 'USER_NUMBERS':
      return true;
    case 'USER_NUMBERS_SUCCESS':
    case 'USER_NUMBERS_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultActiveNumbersTab = 'user';
const activeNumbersTab = (state = defaultActiveNumbersTab, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_NUMBERS_TAB':
      return action.tab;
    default: return state;
  }
};

const defaultShowCreateNumber = false;
const addNumberShow = (state = defaultShowCreateNumber, action) => {
  switch (action.type) {
    case 'ADD_NUMBER_SHOW':
    case 'ADD_NUMBER':
    case 'ADD_NUMBER_ERROR':
      return true;
    case 'ADD_NUMBER_SUCCESS':
    case 'ADD_NUMBER_CANCEL':
    case 'ADD_EMAIL_FIELD_CHANGE_CANCEL':
      return false;
    default:
      return state;
  }
};

const defaultShowEditNumber = false;
const editNumberShow = (state = defaultShowEditNumber, action) => {
  switch (action.type) {
    case 'EDIT_NUMBER_SHOW':
    case 'EDIT_NUMBER':
    case 'EDIT_NUMBER_ERROR':
      return true;
    case 'EDIT_NUMBER_SUCCESS':
    case 'UPDATE_NUMBER_SUCCESS':
    case 'EDIT_NUMBER_CANCEL':
    case 'EDIT_EMAIL_FIELD_CHANGE_CANCEL':
      return false;
    default:
      return state;
  }
};

const defaultShowAssign = false;
const assignNumberShow = (state = defaultShowAssign, action) => {
  switch (action.type) {
    case 'ASSIGN_NUMBER_USER_SHOW':
      return true;
    case 'ASSIGN_NUMBER_USER':
    case 'ASSIGN_NUMBER_USER_SUCCESS':
    case 'ASSIGN_NUMBER_USER_ERROR':
    case 'ASSIGN_NUMBER_USER_CANCEL':
      return false;
    default:
      return state;
  }
};

const defaultFilterNumbersByCompany = {
  filter: null,
  pagination: null,
  number: null
};
const filterNumbersByCompany = (state = defaultFilterNumbersByCompany, action) => {
  switch (action.type) {
    case 'FILTER_NUMBER_BY_COMPANY':
      return {
        ...state,
        filter: action.filter
      }
    case 'FILTER_PAGINATION':
      return {
        ...state,
        pagination: action.pagination
      }
    case 'COMPANY_NUMBERS_SUCCESS':
      return {
        ...state,
        number: action.numbers
      }
    case 'FILTER_NUMBER_BY_COMPANY_CANCEL':
      return defaultFilterNumbersByCompany
    default:
      return state;
  }
};

const defaultAddNumberFieldChange = [];
const addNumberFieldChange = (state = defaultAddNumberFieldChange, action) => {
  switch (action.type) {
    case 'ADD_EMAIL_FIELD_CHANGE':
      return action.emails
    case 'ADD_EMAIL_FIELD_CHANGE_CANCEL':
      return defaultAddNumberFieldChange
    default:
      return state;
  }
};

const defaultEditNumberFieldChange = [];
const editNumberFieldChange = (state = defaultEditNumberFieldChange, action) => {
  switch (action.type) {
    case 'EDIT_ALL_EMAIL_FIELD_CHANGE':
      return action.emails
    case 'EDIT_ALL_EMAIL_FIELD_CHANGE_CANCEL':
      return defaultEditNumberFieldChange
    default:
      return state;
  }
};

const defaultForwardUri = [];
const addForwardUri = (state = defaultForwardUri, action) => {
  switch (action.type) {
    case 'GET_FORWARD_URI_SUCCESS':
      return action.forwardUri
    case 'GET_FORWARD_URI_CANCEL':
      return defaultForwardUri;
    default:
      return state;
  }
};

export default combineReducers({
  loadingUserNumbers,
  loadingCompanyNumbers,
  loadingAllNumbers,
  activeNumbersTab,
  addNumberShow,
  addNumber,
  editNumberShow,
  editNumber,
  assignNumber,
  assignNumberShow,
  filterNumbersByCompany,
  addNumberFieldChange,
  editNumberFieldChange,
  addForwardUri
});
